export default "__VITE_ASSET__DjX1tLHG__"